import ResponsiveHelper from "../utils/ResponsiveHelper";
import CustomProductPage from "./CustomProductPage";
import Booking from "../components/Booking.js";
import BookingSummary from "../components/BookingSummary.js";

export default class Workshop {
  constructor(dom) {
    this.dom = dom;
    this.booking;
    this.pageCustProduct;
    this.bookingSummary;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
    this.initSelection();
    this.initBookingSummary();
    this.initBooking();
    this.initFormBtn();
    //this.initSelection();
    this.initStepControl();
    
    let custProductPage = document.querySelector("#page-cust-product-workshop");
    if (custProductPage) {
      this.pageCustProduct = new CustomProductPage(custProductPage);
      this.pageCustProduct.init();
  
      const btnGetConfig = document.querySelector("[js-getConfig]");
      btnGetConfig.addEventListener("click", () => {
        this.pageCustProduct.getFullConfig();
      });
    }
    this.updateStep();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initSelection() {
    // let sl = document.querySelector("[js-selection]");

    let btns = document.querySelectorAll("[js-sl-btn]");
    let selectedEl;
    
    let radio = document.querySelector("[js-sl-radio]");
    // const _f_btn = document.querySelector("[js-f-sl-btn]");

    for (let btn of btns) {
      btn.addEventListener("click", (e) => {
        // console.lo;
        e.preventDefault();
        
        let locationInput = document.querySelector("input[name=location]");
        if(locationInput){
          locationInput.value = e.target.getAttribute('data-address');
          this.booking.unitID  = e.target.getAttribute('data-unitid');
          this.booking.update();

          let selectedDate = this.booking.getCurrentDate();
          this.booking.pickBookingDate(selectedDate);

          this.bookingSummary.update('location',this.booking.unitID);

        }
        
        if(radio){
          radio.classList.add("active");
          // radio.scrollIntoView({ behavior: "smooth" });
        }else{
          let btn = document.querySelector(".workshop-steps button[js-f-sl-btn]");
          btn.classList.add("active");
        }
        // _f_btn.classList.add("visible");

        setTimeout(() => {
          selectedEl && selectedEl.classList.remove("selected");
          selectedEl = btn;
          btn.classList.add("selected");

          let triggerVal = e.target.dataset.address;
          // console.log(triggerVal);

          let addresses = document.querySelectorAll(".address-item");
          for (let add of addresses) {
            let linkedVal = add.dataset.address;
            let seltedAdd;
            if (linkedVal === triggerVal) {
              seltedAdd && seltedAdd.classList.remove("visible");
              seltedAdd = add;
              add.classList.add("visible");
            } else {
              add.classList.remove("visible");
            }
          }

          //
        }, 100);
      });
    }
  }

  initFormBtn() {
    const btn = document.querySelector(".workshop-steps"+" .timeslot-container "+"button[js-f-sl-btn]");
    const radios = document.querySelectorAll("[js-radio]");
    const bookingSummary = this.bookingSummary;
    if(radios){
      for (let rad of radios) {
        rad.addEventListener("change", (e) => {
          btn.setAttribute( 'data-stepnext', e.target.value);
          // btn.classList.add("active");
          bookingSummary.update('leatherChoice',e.target.value);
          console.log(e.target.value);
          let customOptionWrapper = document.querySelector(".page-wrapper").getAttribute("data-target_class");
          let customsummaryfeild = document.querySelector(
            "." + customOptionWrapper + " textarea.wc-pao-addon-field"
          );
          let addOnSelections = document.querySelectorAll(".wc-pao-addon-select");  
          
          if(e.target.value==4){
            addOnSelections.forEach(addonselect =>{
              addonselect.querySelector('option[data-price]').selected  = true;
            });
            customsummaryfeild.value='{}';
          }else{
            addOnSelections.forEach(addonselect =>{
              addonselect.querySelector('option[data-price]').selected  = false;
            });
            customsummaryfeild.value='';
          }
          
        });
      }
    }
  }

  initBooking() {
    let bookingDOM = document.querySelector("[js-booking]");
    if(bookingDOM){
      this.booking = new Booking(bookingDOM);
      this.booking.bookingSummary = this.bookingSummary;
    }
  }
  initBookingSummary(){
    let bookingSummaryDOM = this.dom.querySelector("#workshop-summary");
    if(bookingSummaryDOM){
      this.bookingSummary = new BookingSummary(bookingSummaryDOM);
      this.bookingSummary.init();
    }
  }
  initStepControl(){
    const nextBtns = document.querySelectorAll("button[js-f-sl-btn], a[js-f-sl-btn]");
    const workshopDom = this.dom;
    const workshopObj = this;
    for (let nextBtn of nextBtns) {
      nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let stepnext = nextBtn.getAttribute( 'data-stepnext');
        // console.log('stepnext '+stepnext);
        this.updateStep(stepnext);
      });
    }
    let presetbuttons = workshopDom.querySelectorAll("button[js-pd-color-opt]");
    presetbuttons.forEach( (presetbutton) => {
      presetbutton.addEventListener('click',()=>{
        let preset = presetbutton.getAttribute('data-preset');
        let input = document.querySelector("input[name=customisation_preset]");
        if (input) {
          input.value = preset;
          workshopObj.pageCustProduct.rebuildSetup();
        }
        workshopDom.querySelector('#workshop-customEditor').classList.add('show');
      });
    });

    let firstLocationBtn = this.dom.querySelector('[js-sl-btn]');
    let choiceBtn = this.dom.querySelector('[js-radio]');
    if(firstLocationBtn){
      firstLocationBtn.click();
    }
    // choiceBtn.click();
    let workshopCustomWrappers = workshopDom.querySelectorAll(".workshop-custom");
    workshopCustomWrappers.forEach( (workshopCustomWrapper) => {
      workshopCustomWrapper.addEventListener('click',(e)=>{
        if(!workshopCustomWrapper.classList.contains('expand')){
          this.toggleWorkshopCustomWrapper();
        }
      //  console.log( workshopCustomWrapper.classList );
      });
    });
  }
  toggleWorkshopCustomWrapper(){
    const workshopDom = this.dom;
    let workshopCustomWrappers = workshopDom.querySelectorAll(".workshop-custom");
    workshopCustomWrappers.forEach( (workshopCustomWrapper) => {
      if(!workshopCustomWrapper.classList.contains('expand')){
        workshopCustomWrapper.classList.add('expand');
      }else{
        workshopCustomWrapper.classList.remove('expand');
      }
    });
  }
  updateStep(stepnext){
    const workshopDom = this.dom;
    const workshopObj = this;
    let workshopsteps = workshopDom.querySelectorAll(".workshop-steps"); 
    if(!stepnext){
      stepnext = 1;
    }
    if(stepnext==3){
      workshopDom.querySelector('.page-products-detail.workshop').classList.remove('show');
    }else{
      workshopDom.querySelector('.page-products-detail.workshop').classList.add('show');
    }
    // for(let tmpStep in workshopsteps ){
    workshopsteps.forEach(function (tmpStep) {
      // console.log(tmpStep);
      if(tmpStep.getAttribute('data-step')==stepnext){
        tmpStep.classList.add('show');
        if(stepnext == 3){
          workshopObj.pageCustProduct.customPartCanvas.resize();
          if(workshopDom.querySelector('.p_colours--item') && !workshopDom.querySelector('.selection-icon').style.backgroundImage ){
            workshopDom.querySelector('.p_colours--item').click(); 
          } 
        }
      }else{
        tmpStep.classList.remove('show');
      }
    });
    if(stepnext==1 || stepnext==4 ){
      workshopDom.querySelector('#section-additonal_info').classList.add('show');
    }else{
      workshopDom.querySelector('#section-additonal_info').classList.remove('show');
    }
    // document.querySelector(".single-product")
    workshopDom.scrollIntoView({ behavior: "smooth" });
  }

  resize() {
    // console.log("resize from Homepage.js");
  }
}